import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./ProcessSection.css";

gsap.registerPlugin(ScrollTrigger);

const steps = [
  "Chemical Treatment",
  "Seasoning",
  "Pre-Cutting",
  "Assembly",
  "Sanding",
  "Polishing",
  "Quality Check",
  "Packaging",
  "Final Inspection",
  "Dispatch",
];

export default function ProcessSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const cards =
      sectionRef.current.querySelectorAll(".process-card");

    cards.forEach((card) => {
      gsap.set(card, {
        opacity: 0,
        y: -150,
        scale: 0.8,
        rotateX: -45,
      });

      ScrollTrigger.create({
        trigger: card,
        start: "top 80%",

        onEnter: () => {
          gsap.to(card, {
            opacity: 1,
            y: 0,
            scale: 1,
            rotateX: 0,
            duration: 1.2,
            ease: "bounce.out",
          });

          card.classList.add("active");
        },

        onLeaveBack: () => {
          gsap.to(card, {
            opacity: 0,
            y: -150,
            scale: 0.8,
            duration: 0.5,
          });

          card.classList.remove("active");
        },
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <section className="process-section" ref={sectionRef}>
      <div className="process-title">
        <span>OUR PROCESS</span>
        <h2>Crafted With Precision</h2>
        <p>
          Every piece follows a carefully monitored journey from raw
          material to final dispatch.
        </p>
      </div>

      <div className="timeline">
        {steps.map((step, index) => (
          <div
            className={`process-card ${
              index % 2 === 0 ? "left" : "right"
            }`}
            key={index}
          >
            <div className="step-circle">
              {String(index + 1).padStart(2, "0")}
            </div>

            <div className="step-box">
              <h3>{step}</h3>
              <div className="step-line"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}